<template>
  <div>
    <a-auto-complete
      v-model:value="name"
      :options="records"
      backfill
      allowClear
      @change="onSelectName"
    >
      <a-input
        v-model:value="name"
        placeholder="请输入或选择联系人"
        :maxlength="10"
        autocomplete="off"
        style="width: 100%"
      >
      </a-input>
      <template #option="item">
        <div @click="onChange(item)">{{ item.name }}</div>
      </template>
    </a-auto-complete>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, watch, toRefs, reactive } from "vue";
import { CompanyContactService } from "@/views/cooperation/company/company-contact.service";
import { values } from "lodash";

export default defineComponent({
  isGlobal: true,
  name: "ParticipantsCreateUser",
  props: {
    value: { type: String, default: "" },
    id: { type: String, default: "" },
    placeholder: { type: String, default: "请选择" },
  },
  emits: ["update:value", "change"],
  setup(props, { attrs, slots, emit }) {
    const state = reactive({
      name: "",
      records: []
    });
    const { data, run, loading } = CompanyContactService.useListApi();

    const onChange = (item, option) => {
      state.name = item.name;
      const { mobile, name } = data?.value?.records.find((v) => v.id == item.id) || { mobile: "" };
      emit("update:value", item.name);
      emit("change", { id: item.id, mobile });
    };

    const onSelectName = (v) => {
      emit("update:value", v);
      emit("change", { id: "0", mobile: "" });
    };
    const onClear = () => {
      emit("update:value", undefined);
      emit("change", undefined);
    };
    watch(
      () => props.id,
      async (n, o) => {
        if (n) {
          await run(props.id); //当新的id没有值时，
          state.records = data?.value?.records as any
        }else {
          state.records = []
        }
      },
      { immediate: true }
    );
    watch(
      () => props.value,
      async (n, o) => {
        if (!n) {
          state.name = "";
        }
      },
      { immediate: true }
    );
    onMounted(async () => {});
    return {
      ...toRefs(state),
      data,
      loading,
      onSelectName,
      onChange,
      onClear,
    };
  },
});
</script>
